import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import center from '@turf/center';
import { AllGeoJSON } from '@turf/helpers';
import { Feature, Geometry } from 'geojson';
import {
  Direction,
  GeoJSON,
  LatLngExpression,
  Layer,
  Map,
  circleMarker,
  geoJSON,
  map,
} from 'leaflet';
import { Subscription } from 'rxjs';
import * as topojson from 'topojson-client';
import { Topology } from 'topojson-specification';
import {
  CIRCLE_MARKER_OPTIONS,
  LEAFLET_MAP_OPTIONS,
  LEAFLET_MAP_STYLE,
  LEAFLET_TOOLTIP_OPTIONS,
} from './../../../constants/indiaData';
import { DashboardService } from 'src/app/services/dashboard.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-state-wise-distribution',
  templateUrl: 'state-wise-distribution.component.html',
  styleUrls: ['state-wise-distribution.component.scss'],
})
export class StateWiseDistribution implements OnInit {
  @Output('stateData') stateData = new EventEmitter<any>;
  public showToolTip:boolean = false;
  private leafletLayer!: GeoJSON;
  private leafletMap!: Map;
  private subscriptions: Subscription[] = [];
  public deptServiceList: any[] = [];
  public filterList: any[] = [];
  protected nationalJsonData!: Topology;
  centerData:any;
  @Output() updateState = new EventEmitter();
  sortingApplied = false;
  cloneList: any;
  @Input()
  set data(val: any) {
    if (val){
      this.deptServiceList = this.sortData(val.data);
      this.cloneList = this.sortData(val?.data)
      this.centerData = this.deptServiceList.find((ele:any)=>ele.id==99)
      console.log(this.centerData);
      this.filterList = JSON.parse(JSON.stringify(this.deptServiceList.filter((ele:any)=>ele.id!=99)));
      console.log(this.filterList)
      this.calculateTotal()
    }
  };
  @Input() currentState: any;
  sortDirection:any = 1;
  total = {
    department:0,
    service:0,
    schemes:0,
    users:0,
    documents:0
  }
  constructor(
    private dashboardService: DashboardService,
    private decimalPipe: DecimalPipe,
    private storeService:StoreService
  ) { }

  ngOnInit(): void {
    this.initMap();
    this.storeService.languageChange.subscribe(()=>{
    })
  }

  calculateTotal() {
    setTimeout(() => {
      // Initialize temporary totals
      let tempTotal = {
        department: 0,
        service: 0,
        schemes: 0,
        documents: 0,
        users: 0
      };
  
      // Calculate the totals
      this.filterList.forEach((ele: any) => {
        if (ele?.departments) tempTotal.department += ele.departments;
        if (ele?.services) tempTotal.service += ele.services;
        if (ele?.schemes) tempTotal.schemes += ele.schemes;
        if (ele?.documents) tempTotal.documents += ele.documents;
        if (ele?.totalUser) tempTotal.users += Number(ele.totalUser);
      });
  
      // Update the main total object
      this.total = { ...tempTotal };
  
      // Emit the final result
      this.stateData.emit({
        schemes: this.total.schemes,
        documents: this.total.documents,
        centerData: this.centerData
      });
  
      console.log("schemes", this.total.schemes);
      console.log("documents", this.total.documents);
      console.log(this.filterList);
    }, 1000);
  }

  onStateChange(state?:string){
    this.currentState = state ? state : this.currentState
    if (this.currentState) {
      this.sortingApplied = false;
      if (this.currentState == '0') {
        this.deptServiceList = this.sortData(this.deptServiceList);
        this.filterList = this.deptServiceList;
      } else {
        const list = this.deptServiceList ;
        const index = list.findIndex(ele => ele.id == this.currentState);
        const removedItem = list.splice(index, 1);
        this.filterList = list;
        this.filterList.unshift(removedItem[0]);
      }
    }
  }

  sortData(arr: any) {
    arr = arr.sort((a: any, b: any) => b.totalUser - a.totalUser);
    return JSON.parse(JSON.stringify(arr));
  }

  onSort(propertName:string,direction:number){
    this.sortDirection = this.sortDirection == -1 ? 1 : -1 ;
    if(propertName==='displayName'){
      if(direction==-1) this.filterList = this.filterList.sort((a:any,b:any)=> b[propertName].localeCompare(a[propertName]))
      else this.filterList = this.filterList.sort((a:any,b:any)=> a[propertName].localeCompare(b[propertName])) 
    }else{
      if(direction>-1) this.filterList = this.filterList.sort((a:any,b:any)=> b[propertName] - a[propertName])
      else this.filterList = this.filterList.sort((a:any,b:any)=> a[propertName] - b[propertName]) 
    }
    this.sortingApplied = true;
  }
   
  private initMap() {
    const jsonResponse = this.dashboardService
      .getIndiaJson()
      .subscribe((json) => {
        this.nationalJsonData = json;
        const center = this.getCenterOfGeoJson(
          this.getLeafletGeoJson('india-states') as AllGeoJSON
        );
        this.leafletMap = map('map', { center, ...LEAFLET_MAP_OPTIONS });
        this.implementLayer('india-states');
      });
    this.subscriptions.push(jsonResponse);
  }

  getUsers(count: any,inK=false, countType?) {
    if(inK){
      if (count >= 1000) {
        return (count / 1000).toFixed(0) ;
      } else {
        return count ? this.decimalPipe.transform(count, '1.0', 'en-US') : '0';
      }
    }else{
      if (count >= 10000000) {
        let result = (count / 10000000).toFixed(2);
        return parseFloat(result) + " Cr";
      } else if (count >= 100000) {
        let result = (count / 100000).toFixed(2);
        return parseFloat(result) + " Lac";
      } else if (count >= 1000) {
        return (count / 1000).toFixed(0) + 'k';
      } else {
        return count ? this.decimalPipe.transform(count, '1.0', 'en-US') : '0';
      }
    }
  }
  private createTooltipContent = (
    name: string,
    dept: number,
    services: number,
    schemes: number,
    users: number,
    documents: number
  ) => {
    return `<p class="count">${name}</p>`;
    // <p>Departments</p>
    // <p class="count">${dept}</p>
    // <p>Services</p>
    // <p class="count">${services}</p>
    // <p>Schemes</p>
    // <p class="count">${schemes}</p>
    // <p>Users</p>
    // <p class="count">${users}</p>
    // <p>Documents</p>
    // <p class="count">${documents}</p>
  };

  private getCenterOfGeoJson = (geoJson: AllGeoJSON) => center(geoJson).geometry.coordinates.reverse() as LatLngExpression;

  private getLeafletGeoJson = (key: string) => topojson.feature(this.nationalJsonData, this.nationalJsonData.objects[key]);

  private getStateDetailsByStateName = (name: string) =>
    this.deptServiceList.find((state) => state.name.toLowerCase() === name.toLowerCase());

  private implementLayer = (geoJsonKey: string): void => {
    const geoJson = this.getLeafletGeoJson(geoJsonKey);
    this.leafletLayer = geoJSON(geoJson, {
      style: ()=>LEAFLET_MAP_STYLE,
      onEachFeature: this.onEachFeature,
    });
    this.leafletMap.addLayer(this.leafletLayer);
    this.leafletMap.fitBounds(this.leafletLayer.getBounds());
    this.addCircleMarker();
  };

  private onEachFeature = (_: Feature<Geometry, unknown>, layer: Layer) => {
    layer.on({
      mouseover: this.leafletHighlight,
      mouseout: () => this.leafletLayer.resetStyle(),
    });
  };

  private leafletHighlight = (event: any, filter?: any) => {
    const layer = event.target;
    let name;
    let dept = 0;
    let services = 0;
    let schemes = 0;
    let users = 0;
    let document = 0;
    let nameToVisible = ''
    name = layer?.feature?.id;
    if(name.includes('&')) name = name.replace('&','and')
    const stateData = this.getStateDetailsByStateName(name);
    if (stateData) {
      dept = stateData.departments;
      services = stateData.services;
      schemes = stateData.schemes;
      users = stateData.totalUser;
      document = stateData.documents;
      nameToVisible = stateData?.displayName
    }

    if (name.toLowerCase() === 'chandigarh' || name.toLowerCase() === 'delhi') {
      return;
    }
    const direction = this.getTooltipDirection(name.toLowerCase());
    layer.bindTooltip(
      this.createTooltipContent(
        nameToVisible,
        dept,
        services,
        schemes,
        users,
        document
      ),
      { ...LEAFLET_TOOLTIP_OPTIONS, direction }
    )
      .openTooltip();
  };

  private addCircleMarker = () => {
    this.leafletMap.eachLayer((layer: any) => {
      let name = '';
      let dept = 0;
      let services = 0;
      let schemes = 0;
      let users = 0;
      let document = 0;
      let nameToVisible = ''
      name = layer?.feature?.id;
      if (name) {
        const stateData: any = this.getStateDetailsByStateName(name);
        if (stateData) {
          dept = stateData.departments;
          services = stateData.services;
          schemes = stateData.schemes;
          users = stateData.totalUser;
          document = stateData.documents;
          nameToVisible = stateData.displayName;
        }
      }
      if (
        'getBounds' in layer &&
        typeof layer.getBounds === 'function' &&
        name &&
        name.toLowerCase() !== 'chandigarh' &&
        name.toLowerCase() !== 'delhi'
      ) {
        const bounds = layer.getBounds();
        if (bounds) {
          const latLng = bounds.getCenter(); // Get the center of the layer
          const mapCircleMarker = circleMarker(latLng, {
            ...CIRCLE_MARKER_OPTIONS,
          });
          const direction = this.getTooltipDirection(name.toLowerCase());
          mapCircleMarker.bindTooltip(
            this.createTooltipContent(
              nameToVisible ,
              dept,
              services,
              schemes,
              users,
              document
            ),
            { ...LEAFLET_TOOLTIP_OPTIONS, direction }
          );
          mapCircleMarker.on('click', e => {
          
          })
          mapCircleMarker.addTo(this.leafletMap);
        }
      }
    });
  };

  extractContent(htmlString: string) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  private getTooltipDirection(name: string) {
    let direction: Direction = 'auto';
    if (
      name === 'andaman & nicobar islands' ||
      name === 'tamil nadu' ||
      name === 'kerala' ||
      name === 'lakshadweep' ||
      name === 'karnataka' ||
      name === 'andhra pradesh' ||
      name === 'puducherry' ||
      name === 'goa'
    ) {
      direction = 'top';
    } else if (
      name === 'ladakh' ||
      name === 'jammu & kashmir' ||
      name === 'himachal pradesh' ||
      name === 'punjab' ||
      name === 'uttarakhand'
    ) {
      direction = 'bottom';
    }
    return direction;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
